export enum TaskType {
    PICKUP = 'PICKUP',
    DELIVERY = 'DELIVERY',
}


export enum PickupTaskState {
    CREATED = "CREATED",
    ASSIGNED = "ASSIGNED",
    IN_PROGRESS = "IN_PROGRESS",
    PICKED_UP = "PICKED_UP",
    COMPLETED = "COMPLETED",
    CANCELLED = "CANCELLED",
    FAILED = "FAILED",
}

export enum OrderDeliveryTaskState {
    SCHEDULED = "SCHEDULED",
    OUT_FOR_DELIVERY = "OUT_FOR_DELIVERY",
    IN_PROGRESS = "IN_PROGRESS",
    AWAITING_RETURN = "AWAITING_RETURN",
    FAILED = "FAILED",
    COMPLETED = "COMPLETED",
}

export enum DeliveryBatchState {
    ASSIGNED = "ASSIGNED",
    OUT_FOR_DELIVERY = "OUT_FOR_DELIVERY",
    CANCELLED = "CANCELLED",
}

export enum PaymentTaskState {
    SCHEDULED = "SCHEDULED",
    OUT_FOR_PAYMENT = "OUT_FOR_PAYMENT",
    IN_PROGRESS = "IN_PROGRESS",
    CANCELLED = "CANCELLED",
    AWAITING_RETURN = "AWAITING_RETURN",
    FAILED = "FAILED",
    COMPLETED = "COMPLETED",
}

export enum InternalTransferTaskState {
    CREATED = "CREATED",
    ASSIGNED = "ASSIGNED",
    COLLECTED = "COLLECTED",
    IN_PROGRESS = "IN_PROGRESS",
    AWAITING_RETURN = "AWAITING_RETURN",
    COMPLETED = "COMPLETED",
    CANCELLED = "CANCELLED",
    FAILED = "FAILED",
}